<template>
  <div class="ecm__cart section__padding">
    <DeleteDialog
      ref="deleteDialogRef"
      v-if="!activeSkeleton"
      @handleDeleteItems="handleDeleteItems"
    />
    <AddAddress
      ref="addAddressRef"
      @handleCreateShipment="handleCreateShipment"
      v-if="!activeSkeleton"
    />
    <CartSkeleton v-if="activeSkeleton" />
    <div class="ecm__cart-blank" v-if="!activeSkeleton && carts.length === 0">
      <div class="ecm__cart-blank__cover">
        <img src="@/assets/images/empty_cart.svg" alt="">
      </div>
      <div class="ecm__cart-blank__desc">
        <p>Oops, your shopping cart is empty</p>
        <p>Come on, fill it with your dream stuff</p>
        <button @click="$router.push('/books')">Start shopping</button>
      </div>
    </div>
    <div class="ecm__cart-items" v-if="!activeSkeleton && carts.length > 0">
      <h3 class="ecm__cart-items__title">Shopping items</h3>
      <div class="ecm__cart-items__actions">
        <Checkbox
          :label="'Select All'"
          v-model="isCheckedItem"
          @change="handleCheckedAllItem"
        />
        <button @click="handleShowDeleteDialog" :disabled="selectedItems.length === 0" class="ecm__cart-items__actions-delete">
          <i class="fas fa-trash-alt"></i> | Delete
        </button>
      </div>
      <div class="ecm__cart-items__container">
        <CardCart
          ref="cartsRef"
          @handleAddQuantity="handleAddQuantity"
          @handleMinusQuantity="handleMinusQuantity"
          @handleCheckItem="handleCheckItem"
          @handleFetchCarts="handleFetchCarts"
          v-for="(item, index) in carts" :key="index"
          :item="item"
        />
      </div>
    </div>
    <div class="ecm__cart-summary" v-if="!activeSkeleton && carts.length > 0">
      <h3 class="ecm__cart-summary__title">Order Summary</h3>
      <div>
        <div class="ecm__cart-summary__total">
          <p>Total {{ bookPronounce }}</p>
          <p>{{ formatDisplayTotalBook(selectedItems) }}</p>
        </div>
        <div class="ecm__cart-summary__total">
          <p>Total</p>
          <p>Rp {{ formatDisplayTotalPriceBook(selectedItems) }}</p>
        </div>
      </div>
      <button
        class="ecm__cart-summary__pay"
        :disabled="selectedItems.length === 0"
        @click="handleCreateShipment"
      >
        Process to checkout
      </button>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/inputs/Checkbox'
import CardCart from '@/components/cart/Card'
import DeleteDialog from '@/components/modals/DeleteItem'
import AddAddress from '@/components/modals/AddAddress'
import CartSkeleton from '@/components/skeleton/Cart'
import formatDisplay from '@/mixins/formatDisplay.js'
import { mapActions } from 'vuex'

export default {
  name: 'Cart',
  mixins: [formatDisplay],
  components: {
    Checkbox,
    CardCart,
    DeleteDialog,
    AddAddress,
    CartSkeleton
  },
  data () {
    return {
      bookPronounce: 'book',
      isCheckedItem: false,
      selectedItems: [],
      carts: [],
      isLoading: true,
      displayEmptyCart: false,
      activeSkeleton: true
    }
  },
  mounted () {
    this.$data.isLoading = true
    this.handleFetchCarts()
  },
  watch: {
    selectedItems: {
      handler (selected) {
        let quantity = 0
        selected.forEach(item => {
          quantity += item.quantity
        })
        if (quantity > 1) {
          this.$data.bookPronounce = 'books'
        } else {
          this.$data.bookPronounce = 'book'
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      fetchCarts: 'cart/fetchCarts',
      checkedAllItem: 'cart/checkedAllItem',
      deteleItems: 'cart/deteleItems',
      fetchCount: 'cart/fetchCount',
      createShipment: 'shipment/createShipment'
    }),
    handleShowDeleteDialog () {
      this.$refs.deleteDialogRef.setIsShow(true, 'all')
    },
    async handleDeleteItems () {
      try {
        const booksId = this.$data.selectedItems.map(cart => {
          return cart.Book.id
        })
        const resp = await this.deteleItems({ booksId })
        if (resp.status === 'success') {
          await this.handleFetchCarts()
          this.fetchCount()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleCheckedAllItem (isSelected) {
      try {
        const resp = await this.checkedAllItem({ isSelected })
        if (resp.msg === 'all selected has been updated') {
          await this.handleFetchCarts()
          this.isCheckedItem = isSelected
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleCheckItem ({ cartItem, isCheckedItem }) {
      if (isCheckedItem) {
        this.$data.selectedItems.push(cartItem)
      } else {
        this.$data.selectedItems = this.$data.selectedItems.filter(item => item.id !== cartItem.id)
      }
      if (this.$data.selectedItems.length === this.$data.carts.length) {
        this.isCheckedItem = true
      } else {
        this.isCheckedItem = false
      }
    },
    handleAddQuantity ({ cartId, quantity }) {
      this.$data.selectedItems.forEach(item => {
        if (item.id === cartId) {
          item.quantity = quantity
        }
      })
    },
    handleMinusQuantity ({ cartId, quantity }) {
      this.$data.selectedItems.forEach(item => {
        if (item.id === cartId) {
          item.quantity = quantity
        }
      })
    },
    async handleFetchCarts () {
      try {
        const resp = await this.fetchCarts()
        this.$data.carts = resp.data
        const selectedItems = this.$data.carts.filter(el => el.is_selected === true)
        this.$data.selectedItems = selectedItems
        if (this.$data.selectedItems.length === this.$data.carts.length) {
          this.isCheckedItem = true
        }
        setTimeout(() => {
          this.$data.activeSkeleton = false
        }, 500);
      } catch (error) {
        console.log(error)
      }
    },
    formatDisplayTotalBook (books) {
      try {
        let totalBooks = 0
        if (books.length > 0) {
          books.forEach(el => {
            totalBooks += el.quantity
          })
        }
        return totalBooks
      } catch (error) {
        return 0
      }
    },
    formatDisplayTotalPriceBook (books) {
      try {
        let totalBooks = 0
        if (books.length > 0) {
          books.forEach(el => {
            totalBooks += el.quantity * el.Book.price
          })
        }
        return this.formatPrice(totalBooks)
      } catch (error) {
        return 0
      }
    },
    async handleCreateShipment () {
      try {
        const resp = await this.createShipment({ items: this.$data.selectedItems })
        if (resp === 'success create shipments') {
          this.$router.push('/checkout')
        }
      } catch (err) {
        if (err?.response?.data?.msg === 'address not found') {
          this.$refs.addAddressRef.setIsShow(true)
          this.$refs.addAddressRef.setIsDisabledChecked(true)
        } else {
          await this.handleFetchCarts()
          if (err?.response?.data?.msg === 'one or the book you bought is missing') {
            this.$message({
              showClose: false,
              message: "This book is no longer available",
              type: 'error',
            })
          } else if (err?.response?.data?.msg === 'Sorry, out of stock') {
            this.$message({
              showClose: false,
              message: "Sorry, out of stock",
              type: 'error',
            })
          } else if (err?.response?.data?.msg === "can't exceed stock limit") {
            this.$message({
              showClose: false,
              message: "can't exceed stock limit",
              type: 'error',
            })
          } else if (err?.response?.data?.msg === "address not found") {
            this.$message({
              showClose: false,
              message: "address not found",
              type: 'error',
            })
          } else {
            this.$message({
              showClose: false,
              message: "internal service error",
              type: 'error',
            })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ecm__cart {
  .ecm__cart-blank {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    .ecm__cart-blank__cover {
      width: 15%;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
    .ecm__cart-blank__desc {
      text-align: center;
      p {
        &:first-child {
          font-weight: 600;
          font-size: 30px;
          color: var(--color-blue-background);
        }
        color: rgba(0, 0, 0, 0.618);
      }
      button {
        margin-top: 20px;
        background: var(--color-blue-background);
        border: none;
        outline: none;
        font-size: 15px;
        padding: 10px 20px;
        color: white;
        font-weight: 600;
        border-radius: 7px;
        cursor: pointer;
      }
    }
  }
  display: flex;
  justify-content: space-between;
  .ecm__cart-items {
    width: 70%;
    padding: 0 20px 0 0;
    .ecm__cart-items__title {
      color: var(--color-blue);
      font-weight: 500;
      font-size: 23px;
      letter-spacing: .5;
    }
    .ecm__cart-items__actions {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ecm__cart-items__actions-delete {
        background: none;
        outline: none;
        border: none;
        font-size: 15px;
        color: red;
        cursor: pointer;
        font-weight: 500;
        &:disabled {
          color: rgb(116, 116, 116);
          cursor: not-allowed;
        }
      }
    }
    .ecm__cart-items__container {
      margin-top: 20px;
    }
  }
  .ecm__cart-summary {
    width: 25%;
    border-radius: 5px;
    border: 2px solid var(--color-blue-background);
    position: sticky;
    top: 2rem;
    padding: 15px;
    height: 170px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .ecm__cart-summary__title {
      font-weight: 500;
      font-size: 17px;
    }
    .ecm__cart-summary__total {
      display: flex;
      justify-content: space-between;
      font-weight: 400;
    }
    .ecm__cart-summary__pay {
      width: 100%;
      border-radius: 5px;
      border: none;
      outline: none;
      height: 35px;
      background: var(--color-blue-background);
      font-weight: 500;
      color: white;
      font-size: 15px;
      cursor: pointer;
      transition: .2s;
      &:disabled {
        cursor: not-allowed;
        background: var(--color-blue);
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .ecm__cart {
    .ecm__cart-items {
      .ecm__cart-items__title {
        font-size: 20px;
      }
      .ecm__cart-items__container {
        .ecm__cart-items__container-item {
          height: 120px;
          .ecm__cart-items__container-item__check {
            padding: 0 20px;
          }
          .ecm__cart-items__container-item__cover {
            width: 70px;
          }
          .ecm__cart-items__container-item__desc,
          .ecm__cart-items__container-item__quantity,
          .ecm__cart-items__container-item__price,
          .ecm__cart-items__container-item__remove {
            height: 55px;
            font-size: 12px;
          }
          .ecm__cart-items__container-item__desc {
            width: 315px;
            .ecm__cart-items__container-item__desc-item {
              .key {
                width: 45px;
              }
            }
          }
          .ecm__cart-items__container-item__quantity {
            margin: 0;
            width: 90px;
            .ecm__cart-items__container-item__quantity-counter {
              .count {
                padding: 0 15px;
              }
              .plus, .minus {
                width: 10px;
              }
            }
          }
          .ecm__cart-items__container-item__price {
            width: 115px;
          }
          .ecm__cart-items__container-item__remove {
            .fa-times-circle {
              font-size: 15px;
            }
          }
        }
      }
    }
    .ecm__cart-summary {
      font-size: 12px;
      height: 140px;
      .ecm__cart-summary__title {
        font-size: 15px;
        padding-bottom: 3px;
      }
      .ecm__cart-summary__pay {
        height: 23px;
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .ecm__cart {
    .ecm__cart-items {
      .ecm__cart-items__container {
        .ecm__cart-items__container-item {
          height: 100px;
          .ecm__cart-items__container-item__check {
            padding: 0 10px;
          }
          .ecm__cart-items__container-item__cover {
            width: 55px;
          }
          .ecm__cart-items__container-item__desc,
          .ecm__cart-items__container-item__quantity,
          .ecm__cart-items__container-item__price,
          .ecm__cart-items__container-item__remove {
            font-size: 10.5px;
          }
          .ecm__cart-items__container-item__desc {
            width: 200px;
            .ecm__cart-items__container-item__desc-item {
              .key {
                width: 40px;
              }
            }
          }
          .ecm__cart-items__container-item__quantity {
            margin: 0 7px;
            width: 70px;
            .ecm__cart-items__container-item__quantity-counter {
              .count {
                padding: 0 10px;
              }
              .plus, .minus {
                width: 10px;
              }
            }
          }
          .ecm__cart-items__container-item__price {
            width: 90px;
          }
          .ecm__cart-items__container-item__remove {
            .fa-times-circle {
              font-size: 13px;
            }
          }
        }
      }
    }
    .ecm__cart-summary {
      font-size: 11px;
      height: 130px;
      flex: 1;
      .ecm__cart-summary__title {
        font-size: 12px;
      }
      .ecm__cart-summary__pay {
        height: 19px;
        font-size: 11px;
      }
    }
  }
}

@media screen and (max-width: 481px) {
  .ecm__cart {
    display: block;
    .ecm__cart-items {
      padding: 0;
      .ecm__cart-items__title {
        margin-bottom: 10px;
      }
      .ecm__cart-items__container {
        .ecm__cart-items__container-item {
          height: 120px;
          .ecm__cart-items__container-item__check {
            padding: 0 10px;
          }
          .ecm__cart-items__container-item__cover {
            width: 70px;
          }
          .ecm__cart-items__container-item__desc,
          .ecm__cart-items__container-item__quantity,
          .ecm__cart-items__container-item__price,
          .ecm__cart-items__container-item__remove {
            font-size: 12px;
          }
          .ecm__cart-items__container-item__desc {
            padding-left: 5px;
            height: 80px;
            width: 250px;
            .ecm__cart-items__container-item__desc-item {
              padding-left: 0;
              &:first-child {
                margin-bottom: 2px;
              }
              .key {
                width: 35px;
                display: none;
              }
            }
            .ecm__cart-items__container-item__quantity {
              margin-top: 10px;
              display: block;
              width: 70px;
              .ecm__cart-items__container-item__quantity-counter {
                padding: 0 2px;
                border-radius: 9px;
                .count {
                  padding: 0 9px;
                }
                .plus, .minus {
                  width: 15px;
                }
              }
            }
          }
          .ecm__cart-items__container-item__quantity,
          .ecm__cart-items__container-item__price {
            display: none;
          }
        }
      }
    }
    .ecm__cart-summary {
      font-size: 13px;
      height: 140px;
      bottom: 0;
      left: 0;
      right: 0;
      .ecm__cart-summary__title {
        font-size: 14px;
      }
      .ecm__cart-summary__pay {
        height: 23px;
        font-size: 13px;
      }
    }
  }
}
</style>
